export const API_URL = "https://panel.cartamovil.com/webservices";
//export const API_URL = "https://panel.dirsacarta.com/webservices";
//export const API_URL = "https://panel.beliverestaurants.com/webservices";
//export const API_URL = "https://panel.alimentariaspearce.com/webservices";
export const TOKEN = "token";
